import { registerAnalytics } from "@humansignal/core";
registerAnalytics();

// ANTZ Mode: Load ANTZ app instead of Label Studio when enabled
// Set ANTZ_MODE=true in environment or .env file to enable
const isAntzMode = process.env.ANTZ_MODE === 'true';

if (isAntzMode) {
  // Load ANTZ Wildlife Research Platform
  import("./antz/main").then(({ renderAntzApp }) => {
    renderAntzApp();
  });
} else {
  // Load original Label Studio app
  import("./app/App");
  import("./utils/service-worker");
}
